import React from "react";
import { useTranslate } from "../../../../components/TranslationText";
import { downloadReportFile } from "../../../../helper/downloadReportFile";
import StatusBadge from "../../../../components/shared/StatusBadge";

/**
 * Table displaying Semen Ownership Certificates.
 * Adheres strictly to EAHS shared horseResultTable & theadHorseSelect styles,
 * matching the exact action/download pattern used in AllServicesRequestsPage.
 *
 * @param {Object} props
 * @param {Array} props.doses - Filtered list of doses
 */
export default function SemenOwnershipTable({ doses = [] }) {
    const { translate } = useTranslate();

    return (
        <div className="scrolableTable mb-main">
            <table className="table table-striped table-bordered rtl horseResultTable">
                <thead className="theadHorseSelect">
                    <tr>
                        <th className="text-center">
                            {translate("web.certificateReferenceNumber", "Certificate Ref. No")}
                        </th>
                        <th className="text-center">
                            {translate("web.stallion", "Stallion")}
                        </th>
                        <th className="text-center">
                            {translate("web.refNo", "Ref. No")}
                        </th>
                        <th className="text-center">
                            {translate("web.doseDate", "Dose Date")}
                        </th>
                        <th className="text-center">
                            {translate("web.status", "Status")}
                        </th>
                        <th className="text-center">
                            {translate("web.download", "Download")}
                        </th>
                    </tr>
                </thead>
                <tbody className="text-center">
                    {doses.length > 0 ? (
                        doses.map((item, index) => {
                            const rowId = item.semenCollectionCertificateId || item.serviceId || index;
                            const stallionDisplayName =
                                item.stallionRegistrationNumber && item.stallionName
                                    ? `${item.stallionRegistrationNumber} - ${item.stallionName}`
                                    : item.stallionRegistrationNumber || item.stallionName || "-";

                            const rawReportUrl = item.reportUrl;

                            return (
                                <tr key={rowId}>
                                    <td style={{ fontSize: 13 }}>
                                        {item.semenDoseReferenceNumber || "-"}
                                    </td>
                                    <td style={{ fontSize: 13, fontWeight: "bold" }}>
                                        {stallionDisplayName}
                                    </td>
                                    <td style={{ fontSize: 13 }}>
                                        {item.serviceReferenceNumber || "-"}
                                    </td>
                                    <td style={{ fontSize: 13 }}>
                                        {item.doseDate}
                                    </td>
                                    <td>
                                        <StatusBadge status={item.status} statusColor={item.statusColor} />
                                    </td>
                                    <td>
                                        {rawReportUrl ? (
                                            <button
                                                type="button"
                                                className="btn btn-link p-0 text-decoration-none"
                                                style={{ color: "inherit", cursor: "pointer" }}
                                                onClick={() => downloadReportFile(rawReportUrl)}
                                                title={translate("web.download", "Download")}
                                            >
                                                <i className="fa fa-download"></i>
                                            </button>
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={6} className="text-center py-4" style={{ color: "#888" }}>
                                {translate("web.noDataFound", "No Data Found !")}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
